// extracted by mini-css-extract-plugin
module.exports =  {"ldapWrapper":"SettingsLdap__ldap-wrapper"};